import { motion, Variants } from "framer-motion";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectInit,
  // selectLanguage,
  // selectTranslations,
} from "../../data-access/store/general/generalSlice";
// import { checkTranslationKey } from "../../../utils/translation";
import "./upstream-service-banner.scss";

const bannerVariants: Variants = {
  hidden: {
    y: "100%",
  },
  visible: {
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
};

export function UpstreamServiceBanner() {
  const init = useAppSelector(selectInit);
  // const lang = useAppSelector(selectLanguage);
  // const translations = useAppSelector(selectTranslations);

  if (!init?.features.withBranding) {
    return <></>;
  }

  return (
    <motion.div
      id="banner-upstream"
      variants={bannerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="banner-area">
        <div className="flex-container">
          <div className="service-text">
            {/*{checkTranslationKey(*/}
            {/*  translations[lang]?.The_service_is_only_available,*/}
            {/*  "The service is only available for subscribers of the specific operator"*/}
            {/*)}*/}
            <img
              style={{ width: "142px" }}
              src="/img/icns/by-africell.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default UpstreamServiceBanner;
